module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/EyeIconGray.71b37d27.svg";